import { useEffect, useState } from "react";
import { PageHeader, Empty } from "@/components/UIBits";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

export default function BurnList() {
  const [rows, setRows] = useState([]);

  const load = async () => {
    try {
      setRows(await api.listBurns());
    } catch {/* ignore */}
  };

  useEffect(() => {
    load();
  }, []);

  const unblock = async (id) => {
    try {
      await api.unblock(id);
      toast.success("Unblocked");
      load();
    } catch {
      toast.error("Failed");
    }
  };

  return (
    <div data-testid="burn-page">
      <PageHeader
        title="Burn List"
        subtitle={`// ${rows.length} strangers blocked`}
        testid="burn-header"
      />

      {rows.length === 0 ? (
        <Empty testid="burn-empty">No burned contacts</Empty>
      ) : (
        <div className="border border-[#1f1f23] overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[#1f1f23] bg-[#0e0e10]">
                {["User Real Number", "Blocked Stranger", "When", ""].map((h) => (
                  <th
                    key={h}
                    className="text-left font-mono text-[10px] uppercase tracking-widest text-zinc-500 px-4 py-3"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((b) => (
                <tr
                  key={b.id}
                  data-testid={`burn-row-${b.id}`}
                  className="border-b border-[#18181b] hover:bg-[#0e0e10]"
                >
                  <td className="px-4 py-3 font-mono">{b.user_real_number}</td>
                  <td className="px-4 py-3 font-mono text-red-400 line-through">
                    {b.stranger_number}
                  </td>
                  <td className="px-4 py-3 font-mono text-xs text-zinc-500">
                    {new Date(b.created_at).toLocaleString()}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <Button
                      size="sm"
                      variant="ghost"
                      data-testid={`burn-unblock-${b.id}`}
                      onClick={() => unblock(b.id)}
                      className="text-zinc-500 hover:text-white"
                    >
                      unblock
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
